// Constantes
export const fontFamily = "helvetica";

// Utilidad para capitalizar texto
export const capitalizeWords = (str) =>
  str
    ? str
        .toLowerCase()
        .split(/([ .])/g)
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join("")
    : "";

// Ajusta texto largo para evitar desbordamiento horizontal
export const adjustText = (doc, text, maxWidth) => {
  return doc.splitTextToSize(text, maxWidth);
};

// Función auxiliar para limpiar texto para nombres de archivo
export const sanitizeFileName = (text) => {
  if (!text) return 'Sin_Datos';
  return text
    .toString()
    .trim()
    // Reemplazar espacios con guiones bajos
    .replace(/\s+/g, '_')
    // Remover caracteres especiales que no son válidos en nombres de archivo
    .replace(/[<>:"/\\|?*]/g, '')
    // Remover caracteres con acentos y convertir a ASCII
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    // Limitar longitud para evitar nombres muy largos
    .substring(0, 50);
};

// Función auxiliar para formatear fecha
export const formatDateForFileName = (dateString) => {
  if (!dateString) return 'Sin_Fecha';
  
  try {
    // ✅ Corregir el manejo de la fecha para evitar problemas de zona horaria
    let date;
    
    // Si la fecha viene en formato ISO (YYYY-MM-DD), procesarla directamente
    if (typeof dateString === 'string' && dateString.match(/^\d{4}-\d{2}-\d{2}$/)) {
      // Para fechas en formato YYYY-MM-DD, crear la fecha usando los componentes
      // para evitar problemas de zona horaria
      const [year, month, day] = dateString.split('-').map(Number);
      date = new Date(year, month - 1, day); // month - 1 porque los meses en JS van de 0-11
    } else {
      // Para otros formatos, usar el constructor normal
      date = new Date(dateString);
    }
    
    // Verificar si la fecha es válida
    if (isNaN(date.getTime())) {
      return 'Sin_Fecha';
    }
    
    // ✅ Formato: YYYY-MM-DD usando los métodos getFullYear, getMonth, getDate
    // que retornan la fecha local sin problemas de zona horaria
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // +1 porque getMonth() retorna 0-11
    const day = String(date.getDate()).padStart(2, '0');
    
    return `${year}-${month}-${day}`;
  } catch (error) {
    console.error('Error formateando fecha:', error);
    return 'Sin_Fecha';
  }
};

// Función para verificar si hay suficiente espacio en la página actual
export const checkPageSpace = (doc, currentY, requiredSpace, addHeaderCallback) => {
  const pageHeight = doc.internal.pageSize.getHeight();
  const bottomMargin = 20; // Margen inferior
  if (currentY + requiredSpace > pageHeight - bottomMargin) {
    doc.addPage();
    addHeaderCallback(doc, 10, doc.tipoMantenimiento); // Agregar encabezado a la nueva página
    return 50; // Ajustar la posición vertical después del encabezado
  }
  return currentY;
};

// Función auxiliar para dibujar placeholder en caso de error
export const drawPlaceholder = (doc, x, y, width, height, message) => {
  doc.setFillColor(240, 240, 240);
  doc.rect(x, y, width, height, 'F');
  doc.setFontSize(8);
  doc.text(message, x + width/2, y + height/2, {align: "center"});
  doc.setFontSize(10);
};

// Función auxiliar para calcular dimensiones manteniendo la proporcionalidad
export const getProportionalDimensions = (imageBase64, maxWidth, maxHeight, cellPadding = 0) => {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      const aspectRatio = img.width / img.height;
      let imgWidth, imgHeight;
      // Si la imagen es horizontal o cuadrada
      if (aspectRatio >= 1) {
        imgWidth = Math.min(maxWidth - (cellPadding * 2), img.width);
        imgHeight = imgWidth / aspectRatio;
        if (imgHeight > maxHeight - (cellPadding * 2)) {
          imgHeight = maxHeight - (cellPadding * 2);
          imgWidth = imgHeight * aspectRatio;
        }
      } else {
        // Imagen vertical
        imgHeight = Math.min(maxHeight - (cellPadding * 2), img.height);
        imgWidth = imgHeight * aspectRatio;
        if (imgWidth > maxWidth - (cellPadding * 2)) {
          imgWidth = maxWidth - (cellPadding * 2);
          imgHeight = imgWidth / aspectRatio;
        }
      }
      resolve({ width: imgWidth, height: imgHeight });
    };
    img.onerror = () => {
      // En caso de error se usan dimensiones por defecto
      resolve({ width: maxWidth / 2, height: maxHeight / 2 });
    };
    img.src = imageBase64;
  });
};
